export const IS_PRODUCTION = process.env.REACT_APP_ENVIRONMENT === 'Production';

export const WELCOME_PAGE = !IS_PRODUCTION;

export const LOGIN_PAGE = !IS_PRODUCTION;

export const TERMS_PAGE = !IS_PRODUCTION;
export const REGISTER_PAGE = !IS_PRODUCTION;
export const REGISTER_PRODUCTION = !IS_PRODUCTION;
export const SEARCH_PROVIDER_PAGE = !IS_PRODUCTION;
export const SEARCH_BUYER_PAGE = !IS_PRODUCTION;
export const SAVED_PROPERTIES_PAGE = !IS_PRODUCTION;
export const PROPERTY_FORM_PAGE = !IS_PRODUCTION;
export const PROPERTY_PERFIL_FORM_PAGE = !IS_PRODUCTION;
export const MY_ACCOUNT_PAGE = !IS_PRODUCTION;
export const PROPERTY_PERFIL_PAGE = !IS_PRODUCTION;

export const SAVE_LOCATION = !IS_PRODUCTION;

export const USER_MODULE = !IS_PRODUCTION;
export const PLACES_MODULE = !IS_PRODUCTION;
export const PROPERTIES_MODULE = !IS_PRODUCTION;
export const PROPERTIES_PRODUCTION_MODULE = !IS_PRODUCTION;
export const SEARCH_MODULE = !IS_PRODUCTION;
